import apiClient from '@/services/rest-api-identity/apiClient'

const baseEndpoint = '/notification'

export const notificationFetures = async () => {
  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint,
  })
  return response?.data.data
}
